const isIE = () => {
  return /* @cc_on!@ */ false || !!document.documentMode;
};

export default isIE;
